import { handleResponseOld, makeGet } from './helpers';

/**
 * @category Item API
 * @see fetchCatalogsTodayCountApi
 */
type FetchCatalogsTodayCountApiParams = {
    deployment: string;
};
/**
 * @category Item API
 * @see fetchCatalogsTodayCountApi
 */
interface FetchCatalogsTodayCountApiResponse {
    data: [
        {
            count: number;
        }
    ];
    message: string;
    success: boolean;
}

/**
 * GET request to Item API service for today's catalogs
 * @function fetchCatalogsTodayCountApi
 * @category Item API
 * @param {FetchCatalogsTodayCountApiParams}
 * @returns {FetchCatalogsTodayCountApiResponse}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/catalogtodaycount
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/get-catalogs-today-count.ts
 */
export const fetchCatalogsTodayCountApi = ({ deployment }: FetchCatalogsTodayCountApiParams) => {
    return new Promise<FetchCatalogsTodayCountApiResponse>((resolve, reject) => {
        const request = makeGet({ deployment, path: '<ITEM-API>spa/small/catalogtodaycount' });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};

export type SearchAuctionFacet = {
    id: string;
    name: string;
    qs: string;
    role: string;
    selected_date?: string;
    selection: string;
    sequence: number;
    total_count?: number;
    type: string;
    values: [
        {
            count: number;
            name: string;
            qs: string;
            selected: boolean;
            sequence: number;
            url: string;
            value: string;
        }?
    ];
};

export type SearchAuctionResult = {
    catid: number;
    ncatalog_status: string;
    sale_start_ts: number;
};

export type AuctionCalendarPayload = {
    count: number;
    facets: SearchAuctionFacet[];
    results: SearchAuctionResult[];
};
/**
 * @category Search API
 * @see {fetchResultsApi}
 */
interface SearchAuctionCalendarResponse {
    error: boolean;
    payload: AuctionCalendarPayload;
}

/**
 * @category Search API
 * @see fetchResultsApi
 */
type FetchResultsApiParams = {
    deployment: string;
    queryParams: any;
};
/**
 * performs GET request to Search service for upcoming calendar auctions
 * @function fetchResultsApi
 * @category Search API
 * @param {FetchResultsApiParams}
 * @returns {SearchAuctionCalendarResponse}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/search/auctioncalendar
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/p8swwvetjb/resources/vbb3uy/methods/GET
 * @see https://github.com/LIVEauctioneers/search-party/blob/master/functions/AuctionCalendarV2/main.go
 */
export const fetchResultsApi = ({ deployment, queryParams }: FetchResultsApiParams) => {
    return new Promise<SearchAuctionCalendarResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'auctioncalendar',
            deployment,
            path: '<SEARCH-API>',
            queryParams,
        });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
};
